export default "__VITE_ASSET__CePMBh_H__"